import React from 'react';
import { Box } from '@mui/material';
import { FeedbackStatus, STATUS_STYLE } from 'features/feedback/shared/feedback.types';

const StatusChip: React.FC<{ status: FeedbackStatus }> = ({ status }) => {
  const s = STATUS_STYLE[status];
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '3px 10px',
        borderRadius: '999px',
        background: s.bg,
        color: s.fg,
        fontSize: 12.5,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: '999px', background: s.dot }} />
      {s.label}
    </Box>
  );
};

export default StatusChip;
